export function LegalSection({ title, children }) {
    return (
        <section className="mb-10">
            <h2 className="font-heading text-xl sm:text-2xl font-bold tracking-tight text-white mb-4">
                {title}
            </h2>
            <div className="space-y-4 text-[#94a3b8] leading-relaxed text-[15px]">
                {children}
            </div>
        </section>
    );
}

export function LegalList({ items }) {
    return (
        <ul className="space-y-2.5">
            {items.map((item, i) => (
                <li key={i} className="flex items-start gap-2.5">
                    <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#00f0ff] shrink-0" />
                    <span>{item}</span>
                </li>
            ))}
        </ul>
    );
}

export default function LegalLayout({ eyebrow, title, updated, intro, children }) {
    return (
        <main data-testid="legal-page" className="min-h-screen">
            <div className="relative pt-32 sm:pt-40 pb-12">
                <div className="absolute inset-0 radial-glow pointer-events-none" />
                <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#00f0ff]/30 to-transparent" />
                <div className="relative max-w-3xl mx-auto px-6 sm:px-10 lg:px-16">
                    <span className="text-[11px] font-bold uppercase tracking-[0.25em] text-[#00f0ff]">
                        {eyebrow}
                    </span>
                    <h1 className="font-heading text-4xl sm:text-6xl font-black tracking-tighter mt-4 leading-[0.95]">
                        {title}
                    </h1>
                    {updated && (
                        <p className="text-sm text-[#64748b] mt-5">Last updated: {updated}</p>
                    )}
                    {intro && (
                        <p className="text-lg text-[#94a3b8] mt-6 leading-relaxed">{intro}</p>
                    )}
                </div>
            </div>

            <section className="relative pb-28">
                <div className="max-w-3xl mx-auto px-6 sm:px-10 lg:px-16">
                    <div className="rounded-2xl bg-[#0a1325] border border-white/10 p-8 sm:p-12">
                        {children}
                    </div>
                </div>
            </section>
        </main>
    );
}
